import { validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import { UNEMPLOYMENT_REASONS as UNEMPLOYMENT_REASON_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';
import type { AnySchema } from 'yup';
import { mixed } from 'yup';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { EmploymentTypeDependencies } from 'entities/creditForm/model/creditForm.constants';

export const validateAnotherUnemploymentReason = (fieldSchema: AnySchema, otherwiseSchema?: AnySchema) =>
  validateConditionaly<TWorkplaceFormFields['anotherUnemploymentReason']>(
    (
      employmentType: TWorkplaceFormFields['employmentType'],
      unemploymentReason: TWorkplaceFormFields['unemploymentReason'],
    ) => {
      if (!employmentType?.value || !unemploymentReason?.value) {
        return false;
      }
      const employmentTypeValue = String(employmentType?.value) as keyof typeof EmploymentTypeDependencies;
      const unemploymentReasonValue = String(unemploymentReason?.value) as ValuesOf<typeof UNEMPLOYMENT_REASON_VALUES>;
      return (
        (EmploymentTypeDependencies[employmentTypeValue] || []).includes('anotherUnemploymentReason') &&
        unemploymentReasonValue === UNEMPLOYMENT_REASON_VALUES.OTHER
      );
    },
    () => fieldSchema,
    () => otherwiseSchema || mixed().optional(),
  )('employmentType', 'unemploymentReason');
